import { render, staticRenderFns } from "./ContactChannelView.vue?vue&type=template&id=1bebaa99&scoped=true"
import script from "./ContactChannelView.vue?vue&type=script&lang=js"
export * from "./ContactChannelView.vue?vue&type=script&lang=js"
import style0 from "./ContactChannelView.vue?vue&type=style&index=0&id=1bebaa99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bebaa99",
  null
  
)

export default component.exports